import React from 'react';
import BottomPopup from './BottomPopup';
import PopupHeader from './PopupHeader';
import { IoCartOutline } from 'react-icons/io5';
import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/system';

const StyledMessageBox = styled(Box)({
    padding: '3rem',
    textAlign: 'center',
    color: '#555',
    minHeight: '200px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
});

const StyledCartIcon = styled(IoCartOutline)({
    fontSize: '3rem',
    color: '#f44336',
    marginBottom: '1rem',
});

const EmptyCartPopup = ({ onClose }) => {
    return (
        <BottomPopup>
            <PopupHeader
                title="Your Cart"
                showBackButton={false}
                onClose={onClose}
            />
            <StyledMessageBox>
                <StyledCartIcon />
                <Typography variant="h6" sx={{ marginBottom: '0.5rem' }}>
                    Your cart is currently empty.
                </Typography>
                <Typography variant="body2" sx={{ color: '#777' }}>
                    Browse our products and add items to your cart to proceed.
                </Typography>
                <Button
                    variant="contained"
                    sx={{
                        background: 'linear-gradient(98.33deg, #FF4500 4.14%, #FF8C00 99.11%)',
                        color: 'white',
                        borderRadius: '25px',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.2)',
                        fontSize: '1rem',
                        padding: '8px 16px',
                        marginTop: 2,
                    }}
                    onClick={onClose}
                >
                    Go Home
                </Button>
            </StyledMessageBox>
        </BottomPopup>
    );
};

export default EmptyCartPopup;